import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const ChatHistorySkeleton = () => (
  <div className={css.skeleton} aria-hidden>
    <div
      data-skeleton-animation
      className={clsJoin(css.block, css.block_top)}
    />
    <div
      data-skeleton-animation
      className={clsJoin(css.block, css.block_large)}
    />
    <div
      data-skeleton-animation
      className={clsJoin(css.block, css.block_medium)}
    />
  </div>
)
